import { Currencies, ExtendedCurrencies } from '@constants/enums';
import { Box, Divider, Typography, useTheme } from '@mui/material';
import { FOUR_DECIMALS_TO_SHOW, formatCurrency } from '@utils/formater';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectRealtimeExchange } from '@/modules/rate/realtime/selectors';
import { RatesTableType } from '../types';
import getStyles from './promoterRates.style';

const ORIGIN_CURRENCY = [Currencies.USD, ExtendedCurrencies.EUR];
const DESTINATION_CURRENCY = [Currencies.MXN];

const RatesTable = () => {
  const { t } = useTranslation();
  const realtimeExchange = useSelector(selectRealtimeExchange);
  const [rates, setRates] = useState<RatesTableType[]>([]);
  const theme = useTheme();
  const styles = getStyles(theme);

  useEffect(() => {
    const filteredRates = Object.values(realtimeExchange || {}).filter(
      (rate) =>
        ORIGIN_CURRENCY.includes(rate.currency as Currencies) &&
        DESTINATION_CURRENCY.includes(
          (rate as unknown as RatesTableType).des_currency
        )
    );
    setRates(filteredRates as unknown as RatesTableType[]);
  }, [realtimeExchange]);

  const renderRate = (rate: RatesTableType, buy: boolean) => (
    <Box
      className={styles.ratesTableRenderRate}
      key={rate.currency + rate.des_currency}
    >
      <Typography className={styles.ratesTableTypography} variant="body2">
        {t(buy ? 'walletExRateBuy' : 'walletExRateSell', {
          currency: '',
        })}
      </Typography>
      <Typography className={styles.ratesTableTypography} variant="body2">
        {formatCurrency(buy ? rate.buy : rate.sell, FOUR_DECIMALS_TO_SHOW)}
      </Typography>
    </Box>
  );

  return (
    <div>
      {rates.map((rate) => (
        <div className="mt-6" key={rate.currency + rate.des_currency}>
          <Typography
            className={styles.ratesTableTypographyMain}
            variant="body2"
          >
            {rate.currency}/{rate.des_currency}
          </Typography>
          <Divider className={styles.ratesTableDivider} />
          {renderRate(rate, true)}
          <Divider className={styles.ratesTableDivider} />
          {renderRate(rate, false)}
          <Divider className={styles.ratesTableDivider} />
        </div>
      ))}
    </div>
  );
};

export default RatesTable;
